import * as React from "react";

import { undefinedIfEmptyString } from "common/Support";
import { asString, loadedDefinedMapWithDefault } from "common/components/component-helpers";
import { LOADING } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { lazilyLoadedComponent } from "lib/react-lazy-loading";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useForce } from "hooks/use-force";
import { ActionSource } from "common/components/computation-types";
import { ErrorBoundary } from "lib/error-boundary";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";

const MarkdownView = lazilyLoadedComponent("markdown-view", () => import("../ui/views/markdown/markdown-view"));

export const MarkdownItemMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[markdown, caption, onTap]] = useForceValueProducers(getValueProducers, force, ctx);
    const { onClick, targetURL } = useOnClickFromAction(onTap, ActionSource.Markdown, ctx, env);

    if (markdown === LOADING) return env.renderProgress();
    if (markdown === undefined) return null;

    const captionString = loadedDefinedMapWithDefault(caption, "", asString);
    return (
        <ErrorBoundary>
            <React.Suspense fallback={<div />}>
                <MarkdownView
                    markdown={asString(markdown)}
                    caption={undefinedIfEmptyString(captionString)}
                    onClick={onClick}
                    targetURL={targetURL}
                />
            </React.Suspense>
        </ErrorBoundary>
    );
};
